import React from 'react';

interface CoveristicLogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'box-red' | 'box-black' | 'text-only' | 'badge';
  withTagline?: boolean;
}

export const CoveristicLogo: React.FC<CoveristicLogoProps> = ({
  className = '',
  size = 'md',
  variant = 'box-red',
  withTagline = false,
}) => {
  const sizeClasses = {
    sm: 'h-7 px-2.5 text-base',
    md: 'h-9 px-4 text-xl',
    lg: 'h-12 px-6 text-2xl',
    xl: 'h-16 px-8 text-3xl',
  };

  if (variant === 'text-only') {
    return (
      <div 
        className={`inline-flex items-center tracking-tight select-none italic ${className}`}
        style={{
          fontFamily: "'Futura PT', 'Futura', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          fontWeight: 700,
          fontStyle: 'italic',
        }}
      >
        <span className="text-[#E21B24]">Cover</span>
        <span className="text-black">istic</span>
      </div>
    );
  }

  const bgClass = variant === 'box-black' ? 'bg-[#111111]' : 'bg-[#E21B24]';

  return (
    <div className={`inline-flex flex-col select-none ${className}`}>
      <div
        className={`inline-flex items-center justify-center ${bgClass} text-white shadow-sm hover:brightness-105 transition-all duration-150 ${sizeClasses[size]}`}
        style={{
          fontFamily: "'Futura PT', 'Futura', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          letterSpacing: '-0.02em',
        }}
      >
        <span 
          className="drop-shadow-sm normal-case italic text-white leading-none"
          style={{
            fontFamily: "'Futura PT', 'Futura', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
            fontWeight: 700,
            fontStyle: 'italic',
          }}
        >
          Coveristic
        </span>
      </div>
      {withTagline && (
        <span className="text-[10px] uppercase font-bold tracking-widest text-[#666666] mt-0.5 ml-0.5">
          Custom Print on Demand
        </span>
      )}
    </div>
  );
};
